import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Technology", href: "#technology" },
  { label: "Treatment Heads", href: "#heads" },
  { label: "Clinical Results", href: "#results" },
  { label: "Gallery", href: "#gallery" },
  { label: "Features", href: "#features" },
];

export default function Navigation({ onRequestDemo }) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="main-navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "glass-nav py-3" : "py-5 bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between">
        {/* Brand */}
        <a href="#" className="flex items-center gap-3" data-testid="brand-logo">
          <span
            className="text-2xl tracking-[0.15em] uppercase font-light"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            <span className="gold-text font-semibold">Ellantes</span>
          </span>
        </a>

        {/* Desktop Links */}
        <div className="hidden lg:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-sm tracking-[0.1em] uppercase text-white/60 hover:text-[#D4AF37] transition-colors duration-300"
              data-testid={`nav-link-${link.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={onRequestDemo}
            className="gold-btn px-6 py-2.5 text-xs tracking-[0.15em] uppercase"
            data-testid="nav-request-demo-btn"
          >
            Request Demo
          </button>
        </div>

        {/* Mobile Toggle */}
        <button
          className="lg:hidden text-white/80 hover:text-[#D4AF37] transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="mobile-menu-toggle"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden glass-nav mt-2 mx-4 p-6 rounded-sm border border-white/5" data-testid="mobile-menu">
          <div className="flex flex-col gap-4">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => handleNavClick(e, link.href)}
                className="text-sm tracking-[0.1em] uppercase text-white/60 hover:text-[#D4AF37] transition-colors py-2"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={onRequestDemo}
              className="gold-btn px-6 py-3 text-xs tracking-[0.15em] uppercase text-center mt-2"
            >
              Request Demo
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}
